var React = require('react');

function ButtonShape05 (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"st2","d":"M0.61,36.13c0,17.87,2.95,38.42,38.32,40.79c29.02,1.95,71.09,1.95,107.01-1.24\n\tc17.9-1.59,31.35-7.12,31.35-29.8c0-31.41-7.67-35.69-26.64-38.43C132.04,4.75,55.25-2.31,27.66,0.76\n\tC13.46,2.34,0.61,4.2,0.61,36.13z"}));
}

ButtonShape05.defaultProps = {"viewBox":"0 0 177.89 78.25"};

module.exports = ButtonShape05;

ButtonShape05.default = ButtonShape05;
